import { render, staticRenderFns } from "./TraxUiCardTestimonial.vue?vue&type=template&id=5cd27468"
import script from "./TraxUiCardTestimonial.vue?vue&type=script&lang=js"
export * from "./TraxUiCardTestimonial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports